import React, { useState, useEffect, useRef } from 'react'
import vic2 from '../../../Assets/claimpro-design-home/recovery-van.png'
import vic3 from '../../../Assets/claimpro-design-home/crane.png'
import mechanic from '../../../Assets/claimpro-design-home/mechanic-home.png'
import inspection from '../../../Assets/claimpro-design-home/vehicle-inspection.png'
import workshop from '../../../Assets/claimpro-design-home/workshop.png'
import legal from '../../../Assets/claimpro-design-home/legal.png'
import './CustomerHome.css'
import axios from "../../../axiosInstance.js";
import { useNavigate } from 'react-router-dom'
import { OlaMaps } from 'olamaps-web-sdk';
import {
    IoLocationSharp,
    IoNotificationsOutline
} from 'react-icons/io5';
import {
    FiChevronDown,
    FiChevronRight,
    FiPhoneCall,
    FiHeadphones,
    FiShield,
    FiUsers,
    FiZap
} from 'react-icons/fi';
import BottomNavigationCustomer from './BottomNavigatonCustomer'
import heroCrane from "../../../Assets/home/home-crane.png";

function Home() {
    const navigate = useNavigate();
    const [address, setAddress] = useState('Fetching location...');
    const [city, setCity] = useState('');
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [recentCases, setRecentCases] = useState([]); // wire up to your real cases API
    const [userData, setUserData] = useState({});
    const [userId, setUserId] = useState(localStorage.getItem('userId'));
    const token = localStorage.getItem('token');

    // ---- Track Recent Cases: live map backdrop refs/state ----
    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const [isMapLoaded, setIsMapLoaded] = useState(false);

    const fetchAddress = async (lat, lng) => {
        try {
            const res = await fetch(
                `https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat},${lng}&api_key=${process.env.REACT_APP_OLA_API_KEY}`
            );
            const data = await res.json();

            const address = data?.results?.[0]?.formatted_address || 'Unknown address';
            setAddress(address);

            const components = data?.results?.[0]?.address_components || [];
            const cityComponent = components.find(comp => comp.types.includes('locality'));
            const city = cityComponent?.long_name || 'City';
            setCity(city);
        } catch (err) {
            console.error('Failed to fetch address', err);
        }
    };

    useEffect(() => {
        const keepKeys = [
            "iconify-version", "iconify-count", "token", "userId", "loginId",
            "loginTime", "userRole", "fromLogin", "justLoggedIn", "gps_location",
            "currentService","userName"
        ];
        Object.keys(localStorage).forEach((key) => {
            if (!keepKeys.includes(key)) localStorage.removeItem(key);
        });
        sessionStorage.clear();

        const interval = setInterval(() => {
            const storedLocation = localStorage.getItem('gps_location');
            if (storedLocation) {
                try {
                    const { lat, lng } = JSON.parse(storedLocation);
                    if (lat && lng) {
                        setLatitude(lat);
                        setLongitude(lng);
                        fetchAddress(lat, lng);
                        clearInterval(interval);
                    }
                } catch (err) {
                    console.error('Failed to parse GPS location:', err);
                }
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            getCurrentLatLong(userId);
        }, 3000);
        return () => clearTimeout(timer);
    }, [userId]);

    useEffect(() => {
    if (!userId) return;

    const fetchActiveCases = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/getActiveQuickServiceRequests/${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setRecentCases((response.data?.requests || []).map(r => ({
                id: r.accidentVehicleCode,
                icon: r.currentService === 'crane' ? vic3 : vic2,
                status: 'progress',
                statusLabel: r.phaseLabel,
                title: r.currentService === 'crane' ? 'Crane Service' : 'Recovery Van',
                vehicleNo: r.vehicleNo,
                location: r.pickupLocation,
                eta: r.phaseLabel,
                resumable: r.phase === 'pre_payment',
                phase: r.phase,
            })));
        } catch (err) {
            console.error('Failed to fetch active cases:', err);
        }
    };

    fetchActiveCases();
}, [userId]);

    const getCurrentLatLong = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getCurrentLatLong/${userId}`);
            const { lat, lng } = response.data.data;
            setLatitude(lat);
            setLongitude(lng);
            localStorage.setItem('gps_location', JSON.stringify({ lat, lng }));
        } catch (error) {
            console.error('Failed to fetch current lat/lng:', error);
        }
    };

    const goToNewService = () => {
        navigate('/add-new-vehicle-driver');
        localStorage.removeItem('formData');
    };
    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return 'Good Morning,';
        if (hour < 17) return 'Good Afternoon,';
        return 'Good Evening,';
    };
    const findUserById = async (id) => {
    try {
        let response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/findById/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        console.log("User fetch response:", response.data);
        if (response.data.message === "No user found") {
            response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getEmployee/${id}/${id}`);
        }
        console.log("User fetch response after fallback:", response.data);
        const user = response.data.data?.[0] || {};
        setUserData(user);
        if (user?.CustomerName) {
            localStorage.setItem('userName', user.CustomerName);
        }
    } catch (error) {
        console.error("Error fetching user:", error.message);
        setUserData({});
    }
};
    // ---- Poll for userId in case the native app injects it after mount ----
    useEffect(() => {
        if (userId) return; // already have it, no need to poll
        const interval = setInterval(() => {
            const uid = localStorage.getItem('userId');
            if (uid) {
                setUserId(uid);
                clearInterval(interval);
            }
        }, 500);
        return () => clearInterval(interval);
    }, [userId]);

     useEffect(() => {
        if (userId) {
            findUserById(userId);
        }
    }, [userId]);

    // ---- Track Recent Cases: init the transparent live-map backdrop ----
    // Only mounts when there are no active cases, and once we have a GPS fix.
    useEffect(() => {
        if (recentCases.length !== 0) return;
        if (!latitude || !longitude) return;
        if (!mapContainerRef.current || mapInstanceRef.current) return;

        const olaMaps = new OlaMaps({
            apiKey: process.env.REACT_APP_OLA_API_KEY,
        });

        const map = olaMaps.init({
            style: 'https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json',
            container: mapContainerRef.current,
            center: [longitude, latitude], // Ola/MapLibre expects [lng, lat]
            zoom: 15,
            interactive: false, // backdrop only, not a controllable map
            attributionControl: { compact: true }, // collapses to a small "i" instead of the full text bar
        });

        map.on('load', () => setIsMapLoaded(true));
        mapInstanceRef.current = map;

        return () => {
            mapInstanceRef.current?.remove?.();
            mapInstanceRef.current = null;
            setIsMapLoaded(false);
        };
    }, [recentCases.length, latitude, longitude]);

    return (
        <>
            <div className="body font-satoshi mb-[6rem]">

                {/* ============ HEADER ============ */}
                <header className="cp-header">
                    <div className="cp-header-logo">
                        <img src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/logo-compressed.png" alt="ClaimPro" />
                    </div>

                    <div className="cp-header-location" onClick={() => navigate('/SearchForLocation')}>
                        <div className="cp-location-icon">
                            <IoLocationSharp />
                        </div>
                        <div className="cp-location-content">
                            <div className="cp-location-city">
                                <span>{city || 'Gurugram'}</span>
                                <FiChevronDown />
                            </div>
                            <p title={address}>{address || 'Fetching location...'}</p>
                        </div>
                    </div>

                    <div className="cp-header-actions">
                        <button type="button" className="cp-notification-btn" aria-label="Notifications">
                            <IoNotificationsOutline />
                            <span className="cp-notification-dot"></span>
                        </button>

                    </div>
                </header>

                {/* ============ HERO ============ */}
                <section className="cp-hero">
                    <div className="cp-hero-main">

                        <div className="cp-hero-content">
                            <p className="cp-hero-greeting">{getGreeting()}</p>
                            <h1 className="cp-hero-name">{userData.CustomerName || 'there'}</h1>
                            <p className="cp-hero-subtitle">We are here to help you, 24/7</p>
                            <p className="cp-hero-hindi">
                                दुर्घटना से <span>समाधान तक</span>
                            </p>

                            <button type="button" className="cp-emergency-btn" onClick={() => (window.location.href = 'tel:+917800784700')}>
                                <span className="cp-emergency-icon">
                                    <FiPhoneCall size={11} />
                                </span>
                                <span className="cp-emergency-text">Get Emergency Help</span>
                                {/* <FiChevronRight className="cp-emergency-arrow" /> */}
                            </button>
                        </div>

                        <div className="cp-hero-image">
                            <img src={heroCrane} alt="ClaimPro roadside crane assistance" />
                        </div>

                        {/* <div className="cp-hero-features">
                            <div className="cp-hero-feature">
                                <div className="cp-feature-icon">
                                    <FiHeadphones size={15} />
                                </div>
                                <div>
                                    <strong>24/7 Assistance</strong>
                                    <span>Round the clock support</span>
                                </div>
                            </div>

                            <div className="cp-feature-divider"></div>

                            <div className="cp-hero-feature">
                                <div className="cp-feature-icon">
                                    <FiShield size={15} />
                                </div>
                                <div>
                                    <strong>500+ Partners</strong>
                                    <span>Verified professionals</span>
                                </div>
                            </div>

                            <div className="cp-feature-divider"></div>

                            <div className="cp-hero-feature">
                                <div className="cp-feature-icon">
                                    <FiZap size={15} />
                                </div>
                                <div>
                                    <strong>Fast Response</strong>
                                    <span>We reach you quicker</span>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </section>

                {/* ============ POPULAR SERVICES ============ */}
                <div className="service-heading">
                    <p>Popular Services</p>
                    <h5 className="cursor-pointer" onClick={() => navigate('/all-services')}>
                        See All <FiChevronRight />
                    </h5>
                </div>

                <div className="cp-services-grid">

                    <div className="cp-service-card" onClick={goToNewService}>
                        <div className="cp-service-stage">
                            <span className="cp-service-badge">24/7</span>
                            <img src={vic2} alt="Recovery Van" />
                        </div>
                        <div className="cp-service-body">
                            <h4>Recovery Van</h4>
                            <div className="cp-service-cta">Book Now <FiChevronRight size={11} /></div>
                        </div>
                    </div>

                    <div className="cp-service-card" onClick={goToNewService}>
                        <div className="cp-service-stage">
                            <span className="cp-service-badge">24/7</span>
                            <img src={vic3} alt="Crane Service" />
                        </div>
                        <div className="cp-service-body">
                            <h4>Crane Service</h4>
                            <div className="cp-service-cta">Book Now <FiChevronRight size={11} /></div>
                        </div>
                    </div>

                    <div className="cp-service-card" onClick={() => navigate('/general-inspection')}>
                        <div className="cp-service-stage">
                            <span className="cp-service-badge">24/7</span>
                            <img src={inspection} alt="Vehicle Inspection" />
                        </div>
                        <div className="cp-service-body">
                            <h4>Vehicle Inspection</h4>
                            <div className="cp-service-cta">Book Now <FiChevronRight size={11} /></div>
                        </div>
                    </div>

                    <div className="cp-service-card" onClick={() => navigate('/customer/workshop-dashboard')}>
                        <div className="cp-service-stage">
                            <span className="cp-service-badge">24/7</span>
                            <img src={workshop} alt="Workshop" />
                        </div>
                        <div className="cp-service-body">
                            <h4>Workshop</h4>
                            <div className="cp-service-cta">Book Now <FiChevronRight size={11} /></div>
                        </div>
                    </div>

                    <div className="cp-service-card">
                        <div className="cp-service-stage">
                            <span className="cp-service-badge soon">Soon</span>
                            <img src={legal} alt="Advocate" />
                        </div>
                        <div className="cp-service-body">
                            <h4>Advocate</h4>
                            <div className="cp-service-cta">Book Now <FiChevronRight size={11} /></div>
                        </div>
                    </div>

                    <div className="cp-service-card">
                        <div className="cp-service-stage">
                            <span className="cp-service-badge soon">Soon</span>
                            <img src={mechanic} alt="Mechanic" />
                        </div>
                        <div className="cp-service-body">
                            <h4>Mechanic</h4>
                            <div className="cp-service-cta">Book Now <FiChevronRight size={11} /></div>
                        </div>
                    </div>

                </div>

                {/* ============ TRACK RECENT CASES ============ */}
                <div className="service-heading">
                    <p>Track Recent Cases</p>
                    {recentCases.length > 0 && (
                        <h5 className="cursor-pointer" onClick={() => navigate('/my-cases')}>
                            See All <FiChevronRight />
                        </h5>
                    )}
                </div>

                {recentCases.length === 0 ? (
                    <div className="cp-cases-empty">
                        <div className={`cp-cases-empty-skeleton ${isMapLoaded ? 'is-hidden' : ''}`} />
                        <div
                            className={`cp-cases-empty-map ${isMapLoaded ? 'is-loaded' : ''}`}
                            ref={mapContainerRef}
                        />

                        <div className="cp-cases-empty-card">
                            <span className="cp-cases-empty-badge">
                                <span className="cp-cases-empty-badge-dot" />
                                Live tracking ready
                            </span>
                            <h4>No cases yet</h4>
                            <p>Once you raise a service request, you'll see your partner's live location right here.</p>
                            <button onClick={goToNewService}>
                                Get Service <FiChevronRight size={13} />
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="cp-cases-list">
                        {recentCases.map((c) => (
                            <div className="cp-case-item" key={c.id} 
                            onClick={() => {
                                if (c.resumable) {
                                    navigate('/addVehicles', {
                                        state: { resumeAccidentVehicleCode: c.id, resumeService: c.currentService }
                                    });
                                } else {
                                    navigate('/driver-status-tracking', { state: { accidentVehicleCode: c.id } });
                                }
                            }}>
                                <div className="cp-case-icon">
                                    <img src={c.icon} alt="" />
                                </div>
                                <div className="cp-case-info">
                                    <span className={`cp-case-status ${c.status === 'completed' ? 'completed' : 'progress'}`}>
                                        {c.statusLabel}
                                    </span>
                                    <p className="cp-case-title">{c.title}</p>
                                    <p className="cp-case-sub">{c.vehicleNo} · {c.location}</p>
                                </div>
                                <div className="cp-case-right">
                                    {c.status === 'completed' ? (
                                        <span className="cp-case-date">{c.date}</span>
                                    ) : (
                                        <div>
                                            <div className="cp-case-eta">{c.eta}</div>
                                            <div className="cp-case-date">Est. Arrival</div>
                                        </div>
                                    )}
                                    <FiChevronRight />
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* ============ WHY CHOOSE CLAIMPRO ============ */}
                <div className="cp-trust-section">
                    <p className="cp-trust-eyebrow">Why ClaimPro</p>
                    <h3 className="cp-trust-heading">You're never stranded alone.</h3>
                    <p className="cp-trust-sub">
                        From the first call to the last repair, we stay with you —
                        verified help, honest pricing, and support that actually shows up.
                    </p>

                    <div className="cp-trust-stats">
                        <div className="cp-trust-item">
                            <div className="cp-trust-icon"><FiShield size={16} /></div>
                            <div>
                                <strong>24/7</strong>
                                <span>Support</span>
                            </div>
                        </div>
                        <div className="cp-trust-item">
                            <div className="cp-trust-icon"><FiUsers size={16} /></div>
                            <div>
                                <strong>500+</strong>
                                <span>Verified Partners</span>
                            </div>
                        </div>
                        <div className="cp-trust-item">
                            <div className="cp-trust-icon"><FiZap size={16} /></div>
                            <div>
                                <strong>15 min</strong>
                                <span>Avg. Response</span>
                            </div>
                        </div>
                        <div className="cp-trust-item">
                            <div className="cp-trust-icon">₹</div>
                            <div>
                                <strong>Transparent</strong>
                                <span>&amp; Fair Pricing</span>
                            </div>
                        </div>
                    </div>

                    <div className="cp-trust-footer">
                        <strong>Trusted by thousands of drivers</strong> across India,
                        one breakdown at a time.
                    </div>
                </div>

                {/* ============ POPULAR OFFERS ============ */}
                <div className="service-heading">
                    <p>Popular Offers</p>
                    {/* <h5 className="cursor-pointer" onClick={() => navigate('/all-offers')}>
                        See All <FiChevronRight />
                    </h5> */}
                </div>

                <div className="cp-offer-banner">
                    <span className="cp-offer-ribbon">Limited Time</span>
                    <span className="cp-offer-pill">UPTO<br />15% OFF</span>
                    <div className="cp-offer-text">
                        <h4>Crane Assistance</h4>
                        <p>Special partner pricing</p>
                        <div className="cp-offer-stat">
                            <span />
                            128 people claimed this week
                        </div>
                        <button onClick={() => navigate('/offers/crane')}>
                            View Offer <FiChevronRight size={12} />
                        </button>
                    </div>
                    <img src={heroCrane} alt="Crane Assistance offer" />
                </div>

            </div>

            {/* ============ FIXED NEED IMMEDIATE HELP BAR ============ */}
            <div className="cp-help-bar">
                <div className="cp-help-bar-left">
                    <div className="cp-help-bar-icon">
                        <FiHeadphones size={15} />
                    </div>
                    <div className="cp-help-bar-text">
                        <strong>Need immediate help?</strong>
                        <span>Our team is ready 24/7</span>
                    </div>
                </div>
                <button onClick={() => navigate("/get-help")}>
                    <FiPhoneCall size={12} /> Call ClaimPro
                </button>
            </div>

            <BottomNavigationCustomer />
        </>
    );
}

export default Home;